import { z } from "zod"

export const editEquipmentUsageSchema = z.object({
  value: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  reason: z.string().min(8, { message: 'Tamanho mínimo: 8 caracteres' }),
  file: z.custom<File>().optional(),
})

export type EditEquipmentUsageValidationSchema = z.infer<typeof editEquipmentUsageSchema>
